import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { Box, Text } from '@campaignhub/suit-theme'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/pro-light-svg-icons'

const DEFAULT_MESSAGES = ['Generating new version...', 'Please wait...']

const GeneratingTile = (props) => {
  const {
    messages = DEFAULT_MESSAGES,
    typeSpeed = 110,
    holdDuration = 2000,
    clearDelay = 250,
  } = props

  const [text, setText] = useState('')
  const timerRef = useRef(null)

  useEffect(() => {
    let phraseIndex = 0
    let charIndex = 0

    const typeTick = () => {
      const word = messages[phraseIndex]
      charIndex += 1
      setText(word.slice(0, charIndex))

      if (charIndex >= word.length){
        timerRef.current = setTimeout(() => {
          setText('')
          charIndex = 0
          phraseIndex = (phraseIndex + 1) % messages.length
          timerRef.current = setTimeout(typeTick, clearDelay)
        }, holdDuration)
      } else {
        timerRef.current = setTimeout(typeTick, typeSpeed)
      }
    }

    timerRef.current = setTimeout(typeTick, typeSpeed)

    return () => clearTimeout(timerRef.current)
  }, [messages, typeSpeed, holdDuration, clearDelay])

  return (
    <Box flexDirection="column" marginBottom="large">
      <Box
        alignItems="center"
        border="1px solid"
        borderColor="#ececec"
        borderRadius={5}
        color="bodyFontLightColor"
        height={182}
        justifyContent="center"
        width="100%"
      >
        <FontAwesomeIcon icon={faSpinner} size="2x" spin />
      </Box>
      <Box flexDirection="row" paddingY="medium" alignItems="center" justifyContent="center">
        <Text color="bodyFontLightColor" fontSize="small">
          {text || ' '}
        </Text>
      </Box>
    </Box>
  )
}

GeneratingTile.propTypes = {
  clearDelay: PropTypes.number,
  holdDuration: PropTypes.number,
  messages: PropTypes.arrayOf(PropTypes.string),
  typeSpeed: PropTypes.number,
}

export default GeneratingTile
